import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import MenuItem, {
  TYPE_MAIN_MENU_ITEM_LINK,
  TYPE_MAIN_MENU_ITEM,
} from './components/menuItem';
import DropdownMenu from './components/dropdownMenu';
import './index.css';

export const TYPE_MAIN_MENU_ITEM_MENU = 'MENU';
export const TYPE_MAIN_MENU_ITEM_DROPDOWN = 'DROPDOWN';
export { TYPE_MAIN_MENU_ITEM_LINK, TYPE_MAIN_MENU_ITEM };

/**
 * Main menu header
 * Top bar main menu located at the top, generally above the header. All items are
 * placed horizontally, with one part on the left and another part on the right side.
 * Each menu item could have the following types:
 * TYPE_MAIN_MENU_ITEM_MENU: Using this type, it is possible to group items to the right or left side
 * TYPE_MAIN_MENU_ITEM_LINK: This kind of item should have a onClick function.
 * TYPE_MAIN_MENU_ITEM: this kind of item has not a onClick function
 * TYPE_MAIN_MENU_ITEM_DROPDOWN: this kind of item shows a dropdown menu (vertical)
 * Popup: to show a popup below the item, the field popup should be defined
 * Parameters (Props):
 * @param array mainMenu: [{
 *   bool active
 *   bool disable: if disable is false, then the onClick event is not userd
 *   string key
 *   string icon: semantic ui icon's name
 *   object (UiIcon) uiIcon: ui-component UiIcon
 *   string colorIcon: if the color is not empty, then this value ignores the
 *                     values determined by the ui mode
 *   string type: [
 *       TYPE_MAIN_MENU_ITEM_MENU,
 *       TYPE_MAIN_MENU_ITEM_LINK,
 *       TYPE_MAIN_MENU_ITEM,
 *       TYPE_MAIN_MENU_ITEM_DROPDOWN]
 *   func onClick
 *   bool showPopupHover: show popup window below the menuItem
 *   array popup [{ title, content }]
 *   string position: [right, left]
 *   array items: array mainMenu
 *  }]
 * @param bool mobileVersion: if this value is true, so only the icon/uiIcon for each item is shown
 *  if the menu item has not icon and uiIcon the the label is shown
 * @param string mode:
 */
export default class MainMenuHeader extends Component {
  constructor(props) {
    super(props);
    this.createMenu = this.createMenu.bind(this);
    this.createItem = this.createItem.bind(this);
  }

  /**
   * Create item
   * @param string type
   * @return object MenuItem
   */
  createItem(itemMenu) {
    const { mobileVersion, mode } = this.props;
    if (itemMenu.type === TYPE_MAIN_MENU_ITEM_DROPDOWN) {
      return (
        <DropdownMenu
          key={itemMenu.key}
          dropdownMenu={itemMenu}
          mobileVersion={mobileVersion}
          mode={mode}
        />
      );
    }
    return (
      <MenuItem mobileVersion={mobileVersion} mode={mode} itemMenu={itemMenu} key={itemMenu.key} />
    );
  }

  /**
   * Create menu
   * @param array menuItems
   */
  createMenu(menuItems) {
    return menuItems.map((menuItem) => this.createItem(menuItem));
  }

  render() {
    const { mainMenu, marginLeftTopBarMenu } = this.props;
    const style = { left: marginLeftTopBarMenu };
    return (
      <Menu className="main-menu-header" borderless fixed="top" style={style}>
        {mainMenu.map((menu) => {
          if (menu.type === TYPE_MAIN_MENU_ITEM_MENU) {
            let menuReturn = (
              <Menu.Menu key={menu.key}>{this.createMenu(menu.items)}</Menu.Menu>
            );
            if (menu.position) {
              menuReturn = (
                <menuReturn.type
                  {...menuReturn.props}
                  {...{ position: menu.position }}
                  key={menu.key}
                />
              );
            }
            return menuReturn;
          }
          return this.createItem(menu);
        })}
      </Menu>
    );
  }
}

MainMenuHeader.propTypes = {
  mainMenu: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      disable: PropTypes.bool,
      key: PropTypes.string,
      icon: PropTypes.string,
      uiIcon: PropTypes.node,
      colorIcon: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
      onClick: PropTypes.func,
      showPopupHover: PropTypes.bool,
      popup: PropTypes.objectOf(
        PropTypes.shape({
          title: PropTypes.string,
          content: PropTypes.object,
        })
      ),
      position: PropTypes.string,
    })
  ).isRequired,
  mobileVersion: PropTypes.bool,
  marginLeftTopBarMenu: PropTypes.string,
  mode: PropTypes.string,
};

MainMenuHeader.defaultProps = {
  mobileVersion: false,
  mode: null,
  marginLeftTopBarMenu: '100px',
};
